module.exports = __webpack_public_path__ + "img/pipe-1.4bfe70a6.jpg";